var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Video extends Component {
    constructor() {
        super('Video', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('body').on('hw-cookies-setting-external-changed', (event) => {
                $('.module-video').each((video) => {
                    const iframe = video.find('iframe');
                    if (event.detail.isEnabled) {
                        iframe.attr('src', iframe.attr('data-src'));
                        video.find('.video-disabled-mask').addClass('d-none').removeClass('d-flex');
                    }
                    else {
                        iframe.attr('src', '');
                        video.find('.video-disabled-mask').addClass('d-flex').removeClass('d-none');
                    }
                });
            });
            $('.btn-play-video').on('click', (event, button) => {
                event.preventDefault();
                const parent = button.parents('.module-video');
                const video = $(window).width() < 992 ? parent.find('video.d-lg-none') : parent.find('video.d-lg-block');
                console.log(video);
                video.attr('controls', 'controls');
                video.get(0).play();
                button.addClass('d-none');
            });
            $('video').on('pause', (event, video) => {
                video.removeAttr('controls');
                video.parents('.module-video').find('.btn-play-video').removeClass('d-none');
            });
            this.success();
        });
    }
}
